import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import PortfolioHome from "@/pages/portfolio/PortfolioHome";
import DesignPage from "@/pages/portfolio/DesignPage";
import ResumePage from "@/pages/resume/ResumePage";
import TribePage, { GoogleCallback } from "@/pages/tribe/TribePage";
import TribeAdmin from "@/pages/tribe/TribeAdmin";
import PremiumPage from "@/pages/tribe/PremiumPage";
import LegalPage from "@/pages/legal/LegalPage";
import ServicesPage from "@/pages/services/ServicesPage";
import ProjectsPage from "@/pages/projects/ProjectsPage";
import IndlangsProposal from "@/pages/IndlangsProposal";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<PortfolioHome />} />
      <Route path="/design-portfolio" element={<DesignPage />} />
      <Route path="/design" element={<Navigate to="/design-portfolio" replace />} />
      <Route path="/resume" element={<ResumePage />} />
      <Route path="/auth/google" element={<GoogleCallback />} />
      <Route path="/tribe" element={<TribePage />} />
      <Route path="/tribe/post/:slug" element={<TribePage />} />
      <Route path="/tribe/admin" element={<TribeAdmin />} />
      <Route path="/premium" element={<PremiumPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/indlangs-proposal" element={<IndlangsProposal />} />
      <Route path="/privacy" element={<LegalPage kind="privacy" />} />
      <Route path="/terms" element={<LegalPage kind="terms" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen noise-overlay">
        <AppRouter />
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
